/**
 * @fileoverview Single Product Page Functionality
 * @description Implements product image galleries and interactive elements for single product pages
 *
 * Features:
 * - Product image gallery with Swiper slider
 * - Thumbnail gallery with sub-slider
 * - Mouse-following text elements for desktop
 * - Responsive behavior
 *
 * HTML Structure Required:
 * - Elements with class "js-media-list" for main product gallery
 * - Elements with class "js-media-sublist" for thumbnail gallery
 * - Elements with class "perfect-fit-description" for product description
 * - Elements with class "button--with-underline--container" for mouse-following text
 */

(function () {
  document.addEventListener('shopify:section:load', function () {
    const slider = new Swiper('.js-media-list', getSliderSettings);
    const subSlider = new Swiper(
      '.js-media-sublist',
      getSubSliderProductSettings
    );
    setTimeout(function () {
      slider.update();
      subSlider.update();
    }, 200);
  });
})();

//button-with-underline
if (window.screen.width > 990) {
  let attachedCompare = false;

  let mainProductSection = document.querySelector('.perfect-fit-description');

  let imageContainerMainProduct = mainProductSection.querySelector(
    '.button--with-underline--container'
  );

  /**
   * @function followMouseMainProduct
   * @description Updates the position of the text container to follow the mouse
   * @param {MouseEvent} event - The mouse move event
   */
  const followMouseMainProduct = (event) => {
    if (imageContainerMainProduct) {
      imageContainerMainProduct.style.left = event.pageX + 'px';
      imageContainerMainProduct.style.top = event.pageY + 30 + 'px';
    }
  };

  /**
   * @function showTextMainProduct
   * @description Shows the mouse-following text and attaches mouse move listener
   */
  function showTextMainProduct() {
    if (!attachedCompare && imageContainerMainProduct) {
      attachedCompare = true;
      imageContainerMainProduct.style.display = 'block';
      document.addEventListener('pointermove', followMouseMainProduct);
    }
  }

  /**
   * @function hideTextMainProduct
   * @description Hides the mouse-following text and removes mouse move listener
   */
  function hideTextMainProduct() {
    if (imageContainerMainProduct) {
      attachedCompare = false;
      imageContainerMainProduct.style.display = '';
      document.removeEventListener('pointermove', followMouseMainProduct);
    }
  }
}
